let popupHost = null;

function ensureHost() {
  if (typeof document === 'undefined') return null;
  if (popupHost && document.body.contains(popupHost)) return popupHost;
  popupHost = document.createElement('div');
  popupHost.id = 'app-popup-host';
  popupHost.style.position = 'fixed';
  popupHost.style.top = '24px';
  popupHost.style.right = '24px';
  popupHost.style.zIndex = '9999';
  popupHost.style.display = 'flex';
  popupHost.style.flexDirection = 'column';
  popupHost.style.gap = '10px';
  popupHost.style.maxWidth = 'min(420px, calc(100vw - 32px))';
  document.body.appendChild(popupHost);
  return popupHost;
}

export function showPopupMessage(message, type = 'error') {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  const text = String(message || '').trim();
  if (!text) return;
  const host = ensureHost();
  if (!host) return;

  const item = document.createElement('div');
  item.setAttribute('role', 'alert');
  item.style.background = type === 'success' ? '#ecfdf3' : '#fef2f2';
  item.style.border = `1px solid ${type === 'success' ? '#86efac' : '#fecaca'}`;
  item.style.color = type === 'success' ? '#166534' : '#991b1b';
  item.style.padding = '12px 14px';
  item.style.borderRadius = '12px';
  item.style.boxShadow = '0 10px 25px rgba(15, 23, 42, 0.16)';
  item.style.fontSize = '13px';
  item.style.fontWeight = '600';
  item.style.lineHeight = '1.3';
  item.style.wordBreak = 'break-word';
  item.textContent = text;

  host.appendChild(item);
  window.setTimeout(() => {
    if (item.parentNode) item.parentNode.removeChild(item);
    if (host.childNodes.length === 0 && host.parentNode) host.parentNode.removeChild(host);
  }, 3600);
}

